var map = {
	"./abborre.svg": "49e6",
	"./al.svg": "a6e5",
	"./brax.svg": "f5a2",
	"./flundra.svg": "2c87",
	"./gadda.svg": "914a",
	"./gos.svg": "a995",
	"./hornsimpa.svg": "1c85",
	"./id.svg": "c1c6",
	"./lake.svg": "5f12",
	"./lax.svg": "4f9c",
	"./loja.svg": "9637",
	"./mort.svg": "a796",
	"./nors.svg": "f81f",
	"./ruda.svg": "5e76",
	"./sarv.svg": "9fea",
	"./sik.svg": "63e6",
	"./skarpsill.svg": "4b14",
	"./smaspigg.svg": "02ff",
	"./stromming.svg": "a7fa",
	"./sutare.svg": "353c",
	"./torsk.svg": "e5fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9e4";